import { Controller } from '@hotwired/stimulus';

export class SetController extends Controller {
  static targets = ['element'];
  static values = {
    dispatchEvent: {
      default: false,
      type: Boolean,
    },
    elementSelector: String,
    eventType: {
      default: 'input',
      type: String,
    },
    key: {
      default: 'value',
      type: String,
    },
    prop: {
      default: 'value',
      type: String,
    },
  };

  update(event) {
    const value = event.params?.[this.keyValue] ?? event.detail?.[this.keyValue];
    const previousValue = this.target[this.propValue];

    if (value === undefined) return;
    if (value === previousValue) return;

    this.target[this.propValue] = value;

    if (this.dispatchEventValue) this.target.dispatchEvent(new Event(this.eventTypeValue));
  }

  get target() {
    if (this.hasElementSelectorValue) return document.querySelector(this.elementSelectorValue);

    return this.hasElementTarget
      ? this.elementTarget
      : this.element;
  }
}
